export type ProductBrowsePreset = {
  slug: string;
  label: string;
  category?: string;
  family?: string;
  title: string;
  description: string;
};

export const productBrowsePresets: readonly ProductBrowsePreset[] = [
  { slug: "transport-fleet", label: "Transport & Fleet", category: "transport", title: "Transport & Fleet PVC Tarpaulin", description: "Exact PVC tarpaulin SKU records for transport and fleet cover requirements." },
  { slug: "tents-structures", label: "Tents & Structures", category: "structures", title: "Tent & Structure PVC Tarpaulin", description: "Exact PVC tarpaulin SKU records for tents, shelters and structure applications." },
  { slug: "industrial-protection", label: "Industrial Protection", category: "industrial", title: "Industrial Protection PVC Tarpaulin", description: "Exact PVC tarpaulin SKU records for industrial protection applications." },
  { slug: "agriculture-growing", label: "Agriculture & Growing", category: "agriculture", title: "Agricultural PVC Tarpaulin", description: "Exact PVC tarpaulin SKU records for agricultural and growing applications." },
  { slug: "water-marine", label: "Water & Marine", category: "water", title: "Water & Marine PVC Tarpaulin", description: "Exact PVC tarpaulin SKU records for water, marine and containment applications." },
  { slug: "surface-print", label: "Surface & Print", category: "surface", title: "Printable & Surface PVC Tarpaulin", description: "Exact PVC tarpaulin SKU records for printable and surface-led applications." },
  { slug: "truck-cover-pvc", label: "Truck Cover PVC", family: "Truck Cover PVC", title: "Truck Cover PVC Tarpaulin", description: "Exact fixed-specification truck cover PVC tarpaulin SKU records." },
  { slug: "architectural-pvc", label: "Architectural PVC", family: "Architectural PVC", title: "Architectural PVC Tarpaulin", description: "Exact fixed-specification architectural PVC material SKU records." },
  { slug: "pvc-coated", label: "PVC Coated", family: "PVC Coated", title: "PVC Coated Tarpaulin", description: "Exact fixed-specification PVC coated tarpaulin SKU records." },
  { slug: "pvc-laminated", label: "PVC Laminated", family: "PVC Laminated", title: "PVC Laminated Tarpaulin", description: "Exact fixed-specification PVC laminated tarpaulin SKU records." },
  { slug: "pvc-mesh", label: "PVC Mesh", family: "PVC Mesh", title: "PVC Mesh Tarpaulin", description: "Exact fixed-specification PVC mesh tarpaulin SKU records." },
];

export const productBrowsePath = (slug: ProductBrowsePreset["slug"]) => `/products/${slug}`;

export function productBrowsePresetForPathname(pathname: string): ProductBrowsePreset | undefined {
  const slug = pathname.replace(/\/+$/, "").split("/").pop();
  return productBrowsePresets.find((preset) => preset.slug === slug);
}

export function productBrowsePathForLegacyQuery(query: { category?: unknown; family?: unknown }): string | undefined {
  const category = typeof query.category === "string" ? query.category : undefined;
  const family = typeof query.family === "string" ? query.family : undefined;
  const matchingPreset = productBrowsePresets.find((preset) =>
    (Boolean(category) && preset.category === category) || (Boolean(family) && preset.family === family)
  );
  return matchingPreset ? productBrowsePath(matchingPreset.slug) : undefined;
}

export function normalizeProductBrowseHref(href: string): string {
  if (!href.startsWith("/products?")) return href;
  const params = new URLSearchParams(href.slice(href.indexOf("?") + 1));
  return productBrowsePathForLegacyQuery({
    category: params.get("category") ?? undefined,
    family: params.get("family") ?? undefined,
  }) ?? href;
}
